import { Avatar, CardHeader } from "@mui/material";
import { ReactNode } from "react";
import LogoWhite from "../../assets/logo-white.png";

export const DialogHeader = ({ title, subheader = null }: { title: string; subheader?: string | ReactNode | null }) => (
  <CardHeader
    title={title}
    sx={{
      backgroundColor: "#000",
      color: "#FFF",
      margin: -2,
      mb: 2,
      px: 2,
      py: 3,
    }}
    titleTypographyProps={{
      variant: "h6",
    }}
    subheaderTypographyProps={{
      fontSize: 11,
      color: "#FFF",
    }}
    avatar={<Avatar src={LogoWhite} sx={{ backgroundColor: "black" }} />}
    subheader={subheader}
  />
);
